<script>
  import { db } from "../etc/firebase.js"
  import {
    userGuaCount,
    userStore,
    guaRecordStore,
    selectedLanguage,
  } from "../etc/store.js"
  import PrivatePage from "./PrivatePage.svelte"
  import HandQi from "../utils/HandQi.svelte"
  import AutoQi from "../utils/AutoQi.svelte"
  import AesCtr from "../etc/aes-ctr.js"
  import {
    btn_style_blue_d2,
    btn_style_deep_purple_a1,
    btn_style_orange_d2,
    btn_style_yellow_d3,
    btn_style_blue_d3,
    btn_style_green_d3,
    btn_style_teal,
    xiyiSalt,
  } from "../etc/helpers"
  import UploadCSV from "../utils/UploadCSV.svelte"

  let firebaseUid = ""
  let userName = ""
  let isLogin = false

  // Listen for auth status change
  $: if ($userStore.isLogin == true) {
    isLogin = true
    firebaseUid = $userStore.userInfo.firebaseUid
    userName = $userStore.userInfo.userName
    // console.log("@ Qi: getting firebaseUid : ", firebaseUid)
    // console.log("@ Qi: getting userName : ", userName)
  } else {
    isLogin = false
  }

  let manualType = false
  let autoType = false

  const backToQi = () => {
    // console.log("I am back to Qi")
    manualType = false
    autoType = false
  }

  const showHandQi = () => {
    // console.log("I am in showHandQi")
    manualType = true
    autoType = false
  }

  const showAutoQi = () => {
    //  console.log("I am in showAutoQi")
    manualType = false
    autoType = true
  }

  function json2db(file) {
    // console.log("I am getting the json file: ", file)
    // console.log("I am getting the 1st gua: ", file[1])
    // console.log("I am getting the 1st gua qiGuaPerson: ", file[1][0])

    let guaArray = []
    let guaCount = 0
    let dt = new Date(Date.now())
    let prepExplanation = ""

    // get rid of header row and build doc object
    for (var i = 1; i < file.length; i++) {
      if (file[i] != null && file[i][3] != null) {
        // prep for explanation
        // if (file[i][6] != null) {
        //   prepExplanation =
        //     "<hr/><strong>更新日期：</strong>" +
        //     dt +
        //     "<br/><strong>解卦如下：</strong><br/><my_explanation>" +
        //     file[i][6].trim() +
        //     "</my_explanation>"
        // } else {
        //   prepExplanation =
        //     "<hr/><strong>更新日期：</strong>" +
        //     dt +
        //     "<br/><strong>解卦如下：</strong><br/><my_explanation>" +
        //     "" +
        //     "</my_explanation>"
        // }

        if (file[i][6] != null) {
          prepExplanation = file[i][6].trim()
        } else {
          prepExplanation = ""
        }

        let recordDT = Date.now()

        let guaObj = {
          firebaseUid: firebaseUid,
          recorder: userName,
          recordDT: recordDT,
          guaType: "upload",
          qiGuaPerson: file[i][0] != null ? file[i][0].trim() : "",
          qiGuaDT: file[i][1] != null ? file[i][1].trim() : "",
          encryptionOn: true,
          question:
            file[i][2] != null
              ? AesCtr.encrypt(file[i][2].trim(), xiyiSalt, 256)
              : AesCtr.encrypt("", xiyiSalt, 256),
          // question: file[i][2] != null ? file[i][2].trim() : "",
          guaNumbers: file[i][3] != null ? file[i][3].trim() : "",
          category: file[i][4] != null ? file[i][4].trim() : "",
          tag: [],
          // explanation: file[i][6] != null ? file[i][6].trim() : "",
          explanation: {
            dt: new Date(recordDT).toString(),
            content: AesCtr.encrypt(prepExplanation, xiyiSalt, 256),
          },
          // comment,
        }
        guaArray.push(guaObj)
      }
    }

    // console.log("@ Qi.guaArray.length = " + guaArray.length)

    let batch = db.batch()
    let tmp_count = 0
    guaArray.forEach((doc) => {
      let docRef = db.collection("guaRecords").doc() //automatically generate unique id
      batch.set(docRef, doc)
      tmp_count++
    })
    batch.commit()

    updateGuaRecordStore(firebaseUid)

    // guaCount = $userStore.guaCount
    // console.log(
    //   "@ Qi: getting before upload $userStore.guaCount = " + $userStore.guaCount
    // )
    // console.log("@ Qi: getting before upload guaCount = " + guaCount)
    // guaCount = guaCount + tmp_count
    // $userStore.guaCount = guaCount
    // console.log(
    //   "@ Qi: Added " +
    //     tmp_count +
    //     "new Qua! now $userStore.guaCount = " +
    //     $userStore.guaCount
    // )
  }

  function handleCSVSample() {
    //console.log("I am showing the CSV sample!")
    let header = "起卦人姓名,起卦日期,問題,卦數,類別,標記,解卦<br/>"
    let content = [
      "起卦人姓名,起卦日期,問題,卦數,類別,標記,解卦<br/>",
      "測試人員,2019-08-14,高興嗎,678787,其他,測試,不知道<br/>",
      "測試人員,2019-08-15,吃飽了嗎,678787,其他,測試,大概吃飽了吧<br/>",
      '測試人員,2019-08-16,What happened to food?,678787,其他,測試,"You ate it, your dog ate it, who knows?"<br/>',
      "測試人員,2019-08-17,天氣,678787,其他,測試,天知道<br/>",
      '測試人員,2019-08-18,運動好不好,678787,其他,測試,"當然很好，快去跑步🏃‍♀️🏃"<br/>',
    ]
    let sampleText = ""
    content.forEach((item) => {
      sampleText = sampleText + item
    })
    // var html = "<p>This is 'myWindow'</p>"
    var tab = window.open("about:blank", "_blank")
    tab.document.write(sampleText) // where 'html' is a variable containing your HTML
    tab.document.close() // to finish loading the page
  }

  // Update guaRecordStore (localStorage)
  function updateGuaRecordStore(firebaseUid) {
    // console.log("@ Qi: Updatng GuaRecordStore for UID: " + firebaseUid)

    let guaRecords = []
    let guaCount = 0
    db.collection("guaRecords")
      .where("firebaseUid", "==", firebaseUid)
      .get()
      .then((querySnapshot) => {
        guaCount = 0
        querySnapshot.forEach((doc) => {
          // doc.data() is never undefined for query doc snapshots
          guaCount++
          let tmpArray = doc.data()
          tmpArray.show = true
          tmpArray.id = doc.id
          guaRecords.push(tmpArray)
        })
        // sort the guaRecords per recordDT as default sort.
        //  console.log("@ Record: before sort guaRecords = ", guaRecords)
        guaRecords.sort((a, b) => (a.recordDT < b.recordDT ? 1 : -1))
        //  console.log("@ Record: after sort guaRecords = ", guaRecords)

        // currentUserGuaCount.set(guaCount)
        // $userStore.guaCount = guaCount
        // $userStore.guaRecords = [...guaRecords]
        $guaRecordStore = JSON.stringify(guaRecords)
        $userGuaCount = guaCount
        // console.log(
        //   "@ Qi: guaCount in $userGuaCount is updated = " + $userGuaCount
        // )
        // console.log(
        //   "@ Record: $userStore.guaRecords = ",
        //   $userStore.guaRecords
        // )
        // console.log(
        //   "@ Qi: +++ the refreshed JSON.parse($guaRecordStore) = ",
        //   JSON.parse($guaRecordStore)
        // )
        //location.assign("/records")
        // location.assign("https://www.xiyi.io/#!/records")
        alert("卦例已成功上傳！")
      })
      .catch(function (error) {
        console.log("@ Qi: Error getting guaRecords documents: ", error)
      })
  }
</script>

<main>
  {#if isLogin}
    {#if !manualType && !autoType}
      <h3>起卦</h3>
      <div class="row">
        <div class="col s12 m4">
          <div class="card blue ">
            <div class="card-content white-text">
              <span class="card-title"
                >{$selectedLanguage == "TW" ? "自行輸入" : "自行输入"}</span
              >
              <p>
                {$selectedLanguage == "TW"
                  ? "輸入您的問題、得到的六個爻數、起卦日期、等等資料。您可以立即看到所有卦象、卦辭，也可以隨即加入您的解卦心得。"
                  : "输入您的问题、得到的六个爻数、起卦日期、等等资料。您可以立即看到所有卦象、卦辞，也可以随即加入您的解卦心得。"}
              </p>
            </div>
            <div class="card-action">
              <button on:click={showHandQi} class={btn_style_blue_d3}
                >{$selectedLanguage == "TW" ? "自行輸入" : "自行输入"}
              </button>
            </div>
          </div>
        </div>
        <div class="col s12 m4">
          <div class="card green ">
            <div class="card-content white-text">
              <span class="card-title"
                >{$selectedLanguage == "TW" ? "自動起卦" : "自动起卦"}</span
              >
              <p>
                {$selectedLanguage == "TW"
                  ? "【XiYi習易網】的電腦自動起卦功能是基於大衍占法，模擬人類操作行為而開發出來的。僅供習易參考、千萬不可迷信。"
                  : "【XiYi习易网】的电脑自动起卦功能是基于大衍占法，模拟人类操作行为而开发出来的。仅供习易参考、千万不可迷信。"}
              </p>
            </div>
            <div class="card-action">
              <button on:click={showAutoQi} class={btn_style_green_d3}
                >{$selectedLanguage == "TW" ? "自動起卦" : "自动起卦"}
              </button>
            </div>
          </div>
        </div>
        <div class="col s12 m4">
          <div class="card orange ">
            <div class="card-content white-text">
              <span class="card-title"
                >{$selectedLanguage == "TW" ? "卦例上傳" : "卦例上传"}</span
              >
              <p>
                {$selectedLanguage == "TW"
                  ? "您可以將自己累積的卦例，整理成CSV檔案上傳。請遵照以下範例所規定的格式。"
                  : "您可以将自己累积的卦例，整理成CSV档案上传。请遵照以下范例所规定的格式。"}
              </p>
              <br />
              <!-- svelte-ignore a11y-missing-attribute -->
              <a class={btn_style_yellow_d3} on:click={handleCSVSample}
                >{$selectedLanguage == "TW"
                  ? "CSV 檔案範例"
                  : "CSV 档案范例"}</a
              >
            </div>
            <div class="card-action">
              <UploadCSV
                onUpload={(file) => {
                  json2db(file)
                }}
              />
            </div>
          </div>
        </div>
      </div>
    {/if}
    {#if manualType}
      <!-- <h4>自行輸入</h4> -->
      <a href="/qi" on:click={backToQi} class={btn_style_blue_d2}>回到起卦</a>
      <a href="/records" class={btn_style_deep_purple_a1}>我的卦例</a>
      <HandQi />
    {:else if autoType}
      <!-- <h4>自動起卦</h4> -->
      <a href="/qi" on:click={backToQi} class={btn_style_blue_d2}>回到起卦</a>
      <a href="/records" class={btn_style_deep_purple_a1}>我的卦例</a>

      <AutoQi />
    {/if}
  {:else}
    <PrivatePage />
  {/if}
</main>

<style>
  .btn {
    margin-right: 25px;
  }

  .qitype {
    display: flex;
  }
  .qi-option {
    background-color: #ddbb99;
  }
  /* .top-space {
    padding-top: 8px;
  }
  .space {
    padding-left: 10px;
    margin: 0 5 0 5;
  } */
  .btn-single {
    margin-bottom: 12px;
  }
</style>
